const Misc = {
     sanitizeText: text => {
          return text.replace(/[^a-zA-Z]/g, '');
     },
     generageRandomString: (characters = 10) => {
          let randomString = '';
          const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          for (let i = 0; i < characters; i++) {
               randomString += possible.charAt(Math.floor(Math.random() * possible.length));
          }
          return randomString;
     },
     stateList: () => {
          return [
               'Alabama',
               'Alaska',
               'Arizona',
               'Arkansas',
               'California',
               'Colorado',
               'Connecticut',
               'Delaware',
               'District of Columbia',
               'Florida',
               'Georgia',
               'Hawaii',
               'Idaho',
               'Illinois',
               'Indiana',
               'Iowa',
               'Kansas',
               'Kentucky',
               'Louisiana',
               'Maine',
               'Maryland',
               'Massachusetts',
               'Michigan',
               'Minnesota',
               'Mississippi',
               'Missouri',
               'Montana',
               'Nebraska',
               'Nevada',
               'New Hampshire',
               'New Jersey',
               'New Mexico',
               'New York',
               'North Carolina',
               'North Dakota',
               'Ohio',
               'Oklahoma',
               'Oregon',
               'Pennsylvania',
               'Rhode Island',
               'South Carolina',
               'South Dakota',
               'Tennessee',
               'Texas',
               'Utah',
               'Vermont',
               'Virginia',
               'Washington',
               'West Virginia',
               'Wisconsin',
               'Wyoming',
          ];
     },
};

export default Misc;
